import React from "react";
import { Instagram, Play } from "lucide-react";
import { instagramPosts, INSTAGRAM_URL } from "../mock";

const InstagramFeed = () => {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <h2 className="heading-font text-center text-3xl md:text-4xl tracking-wide">
          SEE IT IN ACTION ON INSTAGRAM
        </h2>
        <p className="text-center text-gray-600 mt-3 mb-10">
          Discover performance that powers every ride.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
          {instagramPosts.map((post, i) => (
            <a
              key={i}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              className="group relative block aspect-[9/12] overflow-hidden bg-black rounded-sm"
            >
              <img
                src={post.image}
                alt={post.caption}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <span className="absolute top-2 right-2 text-white/90">
                <Play size={16} className="fill-white/80" />
              </span>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                <Instagram
                  size={30}
                  className="text-white opacity-0 group-hover:opacity-100 transition-opacity"
                />
              </div>
            </a>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-[#ED1C24] hover:bg-[#c4151c] text-white heading-font tracking-wide px-8 py-3 transition-colors"
          >
            <Instagram size={18} /> Follow Maxima India
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
